import { saveToken, getToken, destroyToken } from '../common/jwt.service';
import ApiService from '../common/api.service';
import router from '../router';

import {
  LOGIN,
  LOGOUT,
  CHECK_AUTH,
} from './actions.type';

import { SET_AUTH, PURGE_AUTH, SET_ERROR } from './mutations.type';

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  errors: null,
  user: null,
  isAuthenticated: !!getToken(),
};

const getters = {
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise((resolve) => {
      ApiService.post('usuarios/login', { username: credentials.email, password: credentials.password })
        .then(({ data }) => {
          if (typeof (data.token) === 'undefined') {
            context.commit(SET_ERROR, [data.message]);
          } else {
            context.commit(SET_AUTH, data);
            resolve(data);
          }
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [CHECK_AUTH](context) {
    if (!getToken()) {
      context.commit(PURGE_AUTH);
      return false;
    }
    ApiService.setHeader();
    return true;
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
    router.push('login');
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, data) {
    state.isAuthenticated = true;
    state.user = {
      username: data.username,
      token: data.token,
      role: data.role,
      id: data.userid,
    };
    state.errors = {};
    saveToken(state.user.token);
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = null;
    state.errors = '';
    destroyToken();
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
